<template>
  <div><h1>yes</h1></div>
</template>

<script>
export default {
  name: 'Reports'
}
</script>

<style scoped>

</style>
